import {
    ROUTES_SETTINGS_ACCOUNT,
    ROUTES_SETTINGS_BILLING,
    ROUTES_SETTINGS_BILLING_LICENCE_EXPIRED,
    ROUTES_SETTINGS_EDIT_CLUB,
    ROUTES_SETTINGS_INTEGRATIONS,
    ROUTES_SETTINGS_INTEGRATIONS_GARMIN_PUSH,
    ROUTES_SETTINGS_INTEGRATIONS_POLAR,
    ROUTES_SETTINGS_INTEGRATIONS_SUUNTO,
    ROUTES_SETTINGS_MY_CLUBS,
    ROUTES_SETTINGS_PRIVACY_SETTINGS
} from '@/constants/routes';

export default {
    path: '/settings',
    name: 'settings',
    component: () => import(/*webpackChunkName: 'settings'*/ '@/views/Settings.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/settings/account',
            name: ROUTES_SETTINGS_ACCOUNT,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/account-details/Account.vue')
        },
        {
            path: '/settings/integrations',
            name: ROUTES_SETTINGS_INTEGRATIONS,
            component: () =>
                import(/*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/Integrations.vue')
        },
        {
            path: '/settings/integrations/garmin-push/connect',
            name: ROUTES_SETTINGS_INTEGRATIONS_GARMIN_PUSH,
            component: () =>
                import(/*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsGarminPush.vue')
        },
        {
            path: '/connect-polar-profile',
            name: ROUTES_SETTINGS_INTEGRATIONS_POLAR,
            component: () =>
                import(/*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsPolar.vue')
        },
        {
            path: '/connect-suunto-profile',
            name: ROUTES_SETTINGS_INTEGRATIONS_SUUNTO,
            component: () =>
                import(/*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsSuunto.vue')
        },
        {
            path: '/settings/billing',
            name: ROUTES_SETTINGS_BILLING,
            component: () => import(/*webpackChunkName: 'settings'*/ '@/components/settings/billing/Billing.vue')
        },
        {
            path: '/settings/billing-licence-expired',
            name: ROUTES_SETTINGS_BILLING_LICENCE_EXPIRED,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/billing-licence-expired/BillingLicenceExpired.vue')
        },
        {
            path: '/settings/my-clubs',
            name: ROUTES_SETTINGS_MY_CLUBS,
            component: () => import(/*webpackChunkName: 'settings'*/ '@/components/settings/my-clubs/ClubsList.vue')
        },
        {
            path: '/settings/edit-club/:id',
            name: ROUTES_SETTINGS_EDIT_CLUB,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/my-clubs/club-details/ClubDetails.vue')
        },
        {
            path: '/settings/privaty-settings',
            name: ROUTES_SETTINGS_PRIVACY_SETTINGS,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/privacy-settings/PrivacySettings.vue')
        }
    ]
};
